import { encodeToBase64 } from './encodeToBase64';

type AuthToken = { password: string; email: string };
let token: AuthToken | null = null;

export function setAuthToken(newToken: AuthToken) {
  token = newToken;
}

export function getAuthCreds() {
  return token;
}

export function getAuthToken(): string | null {
  if (token == null) {
    return null;
  }
  const dataInformation = `${token.email}:${token.password}`;

  return `Basic ${encodeToBase64(dataInformation)}`;
}

export function resetAuthToken() {
  token = null;
}
